export const HORAS_EXTRAS = 'HORAS_EXTRAS';
export const HORAS_EXTRAS_START = 'HORAS_EXTRAS_START';
export const HORAS_EXTRAS_SUCCESS = 'HORAS_EXTRAS_SUCCESS';
export const HORAS_EXTRAS_ERROR = 'HORAS_EXTRAS_ERROR';
export const HORAS_EXTRAS_DETALHES = 'HORAS_EXTRAS_DETALHES';
export const HORAS_EXTRAS_DETALHES_START = 'HORAS_EXTRAS_DETALHES_START';
export const HORAS_EXTRAS_DETALHES_SUCCESS = 'HORAS_EXTRAS_DETALHES_SUCCESS';
export const HORAS_EXTRAS_DETALHES_ERROR = 'HORAS_EXTRAS_DETALHES_ERROR';
